export default "__VITE_ASSET__9e8e8093__"